




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<ToggleInput>({
    model: {
        prop: 'checked',
        event: 'change'
    }
})
export default class ToggleInput extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly checked!: boolean

    @Prop({ type: String, required: false })
    public readonly color!: 'blue' | 'purple' | 'green' | 'grey'

    @Prop({ type: String, required: false })
    public readonly size!: 'small' | 'wide' | 'mobile'

    @Prop({ type: String, required: false, default: 'On' })
    public readonly checkedText!: string

    @Prop({ type: String, required: false, default: 'Off' })
    public readonly unCheckedText!: string

    public id = `toggle-${Math.floor(Date.now() * Math.random())}`

    public get colorClass() {
        if (!this.color) {
            return ''
        }

        return `toggle-label-${this.color}`
    }

    public get sizeClass() {
        if (!this.size) {
            return ''
        }

        return `toggle-label-${this.size}`
    }

    public onChange(event) {
        this.$emit('change', event.target.checked)
    }
}
